import React, { type FunctionComponent } from 'react'
import { type FormikProps } from 'formik'
import { CheckboxGroup } from 'legacy/components/Forms'
import {
  type ProductFormValues,
  type NewProductFormValues,
} from 'legacy/routes/catalog/types/product.types'
import FormSection from './FormSection'
import FormField from './FormField'
import ProductTypeInfoModal from './ProductTypeInfoModal'

type Props = {
  disabled?: boolean
} & (FormikProps<ProductFormValues> | FormikProps<NewProductFormValues>)

export const ATTRIBUTES = [
  'Alcoholic',
  'Fat-Free',
  'Gluten-Free',
  'Kosher',
  'Low-Fat',
  'Organic',
  'Sugar-Free',
  'Vegan',
  'Vegetarian',
]

const ATTRIBUTE_OPTIONS = ATTRIBUTES.map(attribute => ({
  label: attribute,
  value: attribute.toLowerCase(),
}))

export const ProductAttributes: FunctionComponent<Props> = ({ values, handleChange, disabled }) => (
  <FormSection
    titleId="catalog.product.attributes"
    renderAction={() => (values.editable ? null : <ProductTypeInfoModal />)}
  >
    <FormField label="Dietary">
      <CheckboxGroup
        inline
        // FIXME: this prop should just be named `disabled`
        isDisabled={disabled}
        multiple
        name="attributes"
        theme="dark"
        options={ATTRIBUTE_OPTIONS}
        onChange={handleChange}
        values={values.attributes}
      />
    </FormField>
  </FormSection>
)
